var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAkkaColorfull1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221.62 82.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#6d5ca8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.31,
    y1: 52.82,
    x2: 92.24,
    y2: 52.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d5ca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f8dca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 183.69,
    y1: 52.82,
    x2: 221.62,
    y2: 52.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a358a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#6d5ca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 103.2,
    y1: 52.82,
    x2: 177.95,
    y2: 52.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f8dca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a358a3"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.24 32.94 92.24 72.7 85.03 72.7 85.03 39.8 81.36 39.8 77.03 47.48 62.62 72.7 54.31 72.7 77.03 32.94 92.24 32.94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "183.69 32.94 183.69 72.7 190.9 72.7 190.9 39.8 194.57 39.8 198.9 47.48 213.31 72.7 221.62 72.7 198.9 32.94 183.69 32.94"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "177.95 33.6 177.44 32.94 167.09 32.94 132.93 59.59 123.81 47.09 123.81 47.09 141.95 32.94 141.95 32.94 130.23 32.94 110.41 48.41 110.41 32.94 103.2 32.94 103.2 72.7 110.41 72.7 110.41 57.55 118.12 51.53 133.59 72.7 142.49 72.7 137.18 65.42 153.5 52.68 168.12 72.7 177.03 72.7 159.18 48.25 177.95 33.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "68.28 0 11.71 38.92 11.71 56.73 18.36 63.38 18.36 42.42 45.86 23.5 45.86 18.32 68.02 3.08 68.28 0"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "67.1 14.07 67.04 13.97 23.13 44.93 23.13 63.38 29.78 56.73 29.78 48.39 46.37 36.74 46.37 31.48 66.85 17.03 67.1 14.07"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "65.93 28.11 34.6 50.11 34.6 58.72 20.63 72.69 6.65 58.72 6.65 37.31 24.22 24.54 24.22 10.33 18.4 5.68 4.93 14.76 17.56 14.26 17.56 21.15 0 33.92 0 61.48 20.63 82.1 41.25 61.48 41.25 53.59 45.86 50.4 45.86 45.2 65.67 31.23 65.93 28.11"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkkaColorfull1);
export default __webpack_public_path__ + "static/media/akka-colorfull1.e14f6961870541109dba75ec1c36da0e.svg";
export { ForwardRef as ReactComponent };